module.exports = __webpack_public_path__ + "img/flag_es.9179dee2.svg";